// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".boss-guide section.boss-list > div.boss {\n  min-height: 200px;\n}\n.boss-guide section.boss-list > div.boss h3 {\n  text-align: left;\n}\n.boss-guide section.boss-list > div.boss > figure {\n  margin-bottom: 20px;\n}\n.boss-guide section.boss-list > div.boss:nth-of-type(odd) > figure {\n  float: left;\n  margin-right: 20px;\n}\n.boss-guide section.boss-list > div.boss:nth-of-type(even) > figure {\n  float: right;\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
